import React, { useState } from "react"
import { connect, ConnectedProps } from "react-redux"
import { Link } from "react-router-dom"
import { Button, Input, InputGroup, InputGroupText } from "reactstrap"
import { MyIcon } from "src/core/components"
import { PATH } from "src/helpers/paths"
import ApiGeneric from "src/services/apiGeneric"
import { ErrorMessage, FooterForm, Form, Title } from "./Login.styles"
import { login, loginSuccessWithResponse } from "./Login.thunks"
import { useTranslation } from "react-i18next"
import Container from "./LoginContainer"

const mapStateToProps = state => ({
  loading: state.loading,
  isAuthenticated: state.app.isAuthenticated,
})

const mapDispatchToProps = {
  login,
  loginSuccessWithResponse,
}

const connector = connect(mapStateToProps, mapDispatchToProps)

interface Props extends ConnectedProps<typeof connector> {}

const Login = (props: Props) => {
  const { loading } = props
  const { t } = useTranslation()
  const [email, setEmail] = useState("")
  const [error, setError] = useState("")
  const [loadingRequest, setLoadingRequest] = useState(false)
  const [msgSuccess, setMsgSuccess] = useState("")

  const requestForgot = (data = {}) => {
    setLoadingRequest(true)
    ApiGeneric({
      method: "POST",
      url: "Account/ForgotPassword",
      data: data,
    })
      .then(r => {
        setLoadingRequest(false)
        console.warn("r:", r)
        if (r.Msg) {
          setMsgSuccess(r.Msg)
        }
      })
      .catch(err => {
        setLoadingRequest(false)
        console.warn("err:", err)
        if (err && err.msg) {
          setError(err.msg)
        }
      })
  }

  const submit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (!loading) {
      const payload = {
        Email: email,
      }
      requestForgot(payload)
    }
  }

  if (msgSuccess) {
    return (
      <Container loading={loadingRequest}>
        <Form className="p-5 rounded-sm text-center" onSubmit={submit}>
          <Title style={{ marginTop: "0px" }}>
            <div>{t("forgot password.Check Email")}</div>
          </Title>
          <div
            style={{
              fontSize: "14px",
              fontWeight: "normal",
              marginTop: "1rem",
            }}
          >
            {msgSuccess}
          </div>
          <FooterForm>
            <Link to={PATH.LOGIN}>{t("btn.back to signin")}</Link>
          </FooterForm>
        </Form>
      </Container>
    )
  }
  return (
    <Container loading={loadingRequest}>
      <Form className="pd-top-2rem rounded-sm text-center" onSubmit={submit}>
        <Title style={{ marginTop: "0px" }}>
          <div>{t("forgot password.Title")}</div>
          <div
            style={{
              fontSize: "14px",
              fontWeight: "normal",
              marginTop: "1rem",
            }}
          >
            {t("forgot password.Description")}
          </div>
        </Title>
        <InputGroup style={{ marginBottom: "1rem" }}>
          <InputGroupText>
            <MyIcon data="type:HiOutlineMail" />
          </InputGroupText>
          <Input
            placeholder={t("forgot password.Email")}
            autoComplete="on"
            disabled={loadingRequest}
            value={email}
            autoFocus
            onChange={ev => {
              setEmail(ev.currentTarget.value)
            }}
          />
        </InputGroup>
        {error && (
          <ErrorMessage className="mb-3 text-danger text-xl-center">
            {error}
          </ErrorMessage>
        )}
        <Button
          type="submit"
          color="primary"
          style={{ width: "100%" }}
          disabled={loadingRequest}
        >
          {t("btn.forgot password")}
        </Button>
        <FooterForm
          style={{
            justifyContent: "center",
          }}
        >
          <Link to={PATH.LOGIN}>{t("btn.back to signin")}</Link>
        </FooterForm>
      </Form>
    </Container>
  )
}

export default connector(Login)
